import React from 'react'
import { Navigate } from 'react-router-dom'
import { Documente } from '../../containers/MainPage/views'
import DocumenteRoutes from '../../containers/MainPage/routes/DocumentRoutes'
import PartnersView from '../../containers/PartnersPage/views/PartnersView'

export const clubManager = [
  { path: 'documente', element: <Documente /> },
  { path: 'parteneri', element: <PartnersView /> },
  { path: 'documente/*', element: <DocumenteRoutes /> },
  { path: '*', element: <Navigate to="/documente" /> }
]
